import * as React from 'react';
import { FC } from 'react';
import { IMedia, IProduct } from '../../../../../../types';
import ProductCarousel from '../ProductCarousel';

interface ProductContainerProps {
  products: IProduct[];
  parentMedia: IMedia;
  isSingleSection?: boolean;
}

const ProductModalContainer: FC<ProductContainerProps> = ({
  products,
  parentMedia,
  isSingleSection,
}) => {
  return (
    <ProductCarousel
      products={products}
      parentMedia={parentMedia}
      isSingleSection={isSingleSection}
    />
  );
};

export default ProductModalContainer;
